import { useCapabilities } from './CapabilityProvider';
import NotAuthorized from './NotAuthorized';
import NotAuthenticated from './NotAuthenticated';
import AdminSpinner from './ui/AdminSpinner';

/**
 * Route guard: superadmin only (matches backend requireSuperAdmin on deploy routes).
 */
export default function RequireSuperAdmin({ children }) {
  const { loading, isSuperAdmin, isUnauthenticated, isAuthenticated, error } = useCapabilities();

  if (loading) {
    return (
      <div
        style={{
          padding: 'var(--spacing-8)',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 'var(--spacing-2)',
        }}
      >
        <AdminSpinner size="md" />
        <p style={{ marginTop: 'var(--spacing-2)', color: 'var(--color-text-tertiary)' }}>Loading…</p>
      </div>
    );
  }

  if (isUnauthenticated || (error && (error.status === 401 || error.code === 'UNAUTHENTICATED'))) {
    return <NotAuthenticated />;
  }

  if (error && !isAuthenticated) {
    return (
      <div
        style={{
          padding: 'var(--spacing-8)',
          backgroundColor: 'var(--color-semantic-error-bg)',
          color: 'var(--color-semantic-error-text)',
          borderRadius: 'var(--radius-md)',
        }}
      >
        <p>Error loading permissions: {error.message}</p>
      </div>
    );
  }

  if (!isSuperAdmin) {
    return <NotAuthorized requiredCapability="superadmin" />;
  }

  return <>{children}</>;
}
